export type CreateUserDevicePushTokenRequest = {
    devicePushToken: string;
};

export type DeleteUserDevicePushTokenRequest = CreateUserDevicePushTokenRequest;
